export default __webpack_public_path__ + "static/media/tab_qna_active.db490939.svg";